import { render, staticRenderFns } from "./DataSetFile.vue?vue&type=template&id=6bb4631b&scoped=true"
import script from "./DataSetFile.vue?vue&type=script&lang=js"
export * from "./DataSetFile.vue?vue&type=script&lang=js"
import style0 from "./DataSetFile.vue?vue&type=style&index=0&id=6bb4631b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4631b",
  null
  
)

export default component.exports